export default `
query SiteServices($siteId: Int!, $contractorCompanyId: Int!) {
  siteServices(siteId: $siteId, contractorCompanyId: $contractorCompanyId) {
    id
    name
    subServiceId
  }
}
`
